<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title>Ticket Spread</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col>
                <TicketSpread
                  title="Daily"
                  endpoint="/api/v1/stats/daily-tickets-per-agent"
                  :agents="agents"
                />
              </v-col>
              <v-col>
                <TicketSpread
                  title="Weekly"
                  endpoint="/api/v1/stats/weekly-tickets-per-agent"
                  :agents="agents"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title>Tickets per day</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <!-- Line chart -->
            <TicketsPerDay />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title>New tickets per agent</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <TicketsPerAgent />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title>Updates per agent - Past 7 days</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <UpdatesPerAgent />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title>Active Agent cases</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col
                cols="4"
                sm="12"
                md="6"
                lg="4"
                v-for="agent in agents"
                :key="agent.id"
              >
                <CurrentCases
                  v-if="agent.slack_id"
                  :agentEmail="agent.email"
                  :refreshInterval="10000"
                  color="secondary"
                  :image="
                    slackMap[agent.slack_id]
                      ? slackMap[agent.slack_id].image
                      : null
                  "
                  :title="agent.first_name + ' ' + agent.last_name"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TicketsPerDay from "@/components/stats/TicketsPerDay.vue";
import TicketsPerAgent from "@/components/stats/TicketsPerAgent.vue";
import UpdatesPerAgent from "@/components/stats/UpdatesPerAgent.vue";
import CurrentCases from "@/components/CurrentCases.vue";
import TicketSpread from "@/components/stats/TicketSpread.vue";
import axios from "@/plugins/axios";
export default {
  components: {
    TicketsPerDay,
    TicketsPerAgent,
    UpdatesPerAgent,
    CurrentCases,
    TicketSpread,
  },
  name: "StatsView",
  data() {
    return {
      agents: [],
      slackMap: {},
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      let that = this;
      axios.get("/api/v1/agents/list").then((response) => {
        that.agents = response.data.ungrouped;

        that.slackMap = response.data.slackMap;
      });
    },
  },
};
</script>
